import React from "react";
import imgOne from "../../assets/images/services-img1.jpg";
import imgTwo from "../../assets/images/services-img2.jpg";
import imgThree from "../../assets/images/services-img3.jpg";

class VoicePricing extends React.Component {
  render() {
    return (
      <section id="voice-pricing" className="services-area ptb-80">
        <div className="container">
          <div className="section-title">
            <h2>
              Programmable Voice <span>Pricing (US)</span>
            </h2>
            <p>
              Pay only for what you use. The layout below mirrors a typical
              voice pricing page with sections for pay‑as‑you‑go, CPS, phone
              numbers, and in‑depth rate tables. Replace placeholder images as
              desired.
            </p>
          </div>

          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <h3>Pay-as-you-go</h3>
              <p>
                No commitments. Build voice experiences with usage‑based rates
                and optional intelligent services.
              </p>
              <div className="table-responsive">
                <table className="table table-bordered text-start">
                  <thead>
                    <tr>
                      <th>Called number type</th>
                      <th>To make calls</th>
                      <th>To receive calls</th>
                      <th>Refer from Twilio</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Local calls</td>
                      <td>$0.0140 / min</td>
                      <td>$0.0085 / min</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Toll‑free calls</td>
                      <td>$0.0140 / min</td>
                      <td>$0.0220 / min</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>SIP interface</td>
                      <td>$0.0040 / min</td>
                      <td>$0.0040 / min</td>
                      <td>$0.1000 / refer</td>
                    </tr>
                    <tr>
                      <td>Secure media (SIP)</td>
                      <td>Included</td>
                      <td>Included</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Application connect</td>
                      <td>Free</td>
                      <td>$0.0025 / min</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <img className="img-fluid" src={imgOne} alt="Placeholder" />
            </div>
          </div>

          <div className="row pt-5">
            <div className="col-lg-12">
              <div className="section-title">
                <h2>
                  BYOC <span>Trunking</span> Pricing
                </h2>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="table-responsive">
                <table className="table table-bordered text-start">
                  <thead>
                    <tr>
                      <th>Number type used</th>
                      <th>BYOC termination (receive)</th>
                      <th>BYOC origination (make)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>BYOC Trunking</td>
                      <td>$0.0040 / min</td>
                      <td>$0.0040 / min</td>
                    </tr>
                    <tr>
                      <td>Secure media</td>
                      <td>Included</td>
                      <td>Included</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="row pt-5">
            <div className="col-lg-12">
              <h3>Intelligent services</h3>
              <p>Optional add‑ons priced by minute, use, or call.</p>
              <div className="table-responsive">
                <table className="table table-bordered text-start">
                  <thead>
                    <tr>
                      <th>Service</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Conference calls (participant)</td>
                      <td>Starting at $0.0018 / participant / min</td>
                    </tr>
                    <tr>
                      <td>Branded calling</td>
                      <td>$0.12 / call</td>
                    </tr>
                    <tr>
                      <td>Call recording (recording)</td>
                      <td>$0.0025 / min</td>
                    </tr>
                    <tr>
                      <td>Call recording (storage)</td>
                      <td>$0.0005 / min / mo</td>
                    </tr>
                    <tr>
                      <td>Call recording (transcription)</td>
                      <td>$0.0500 / min</td>
                    </tr>
                    <tr>
                      <td>Answering machine detection</td>
                      <td>$0.0075 / call</td>
                    </tr>
                    <tr>
                      <td>Voice Insights advanced (pay‑as‑you‑go)</td>
                      <td>$0.0024 / min</td>
                    </tr>
                    <tr>
                      <td>Emergency calling (per number)</td>
                      <td>$0.75 / mo per number</td>
                    </tr>
                    <tr>
                      <td>Conversational Intelligence – batch transcription</td>
                      <td>$0.024 / min</td>
                    </tr>
                    <tr>
                      <td>Conversational Intelligence – streaming transcription</td>
                      <td>$0.027 / min</td>
                    </tr>
                    <tr>
                      <td>Language Operator – standard</td>
                      <td>$0.0040 / min</td>
                    </tr>
                    <tr>
                      <td>Language Operator – text analysis</td>
                      <td>$0.0035 / min</td>
                    </tr>
                    <tr>
                      <td>Generative Custom Operators – input characters</td>
                      <td>$0.002 / 1k characters</td>
                    </tr>
                    <tr>
                      <td>Generative Custom Operators – output characters</td>
                      <td>$0.018 / 1k characters</td>
                    </tr>
                    <tr>
                      <td>Virtual Agent (Dialogflow CX)</td>
                      <td>$0.085 / min</td>
                    </tr>
                    <tr>
                      <td>SIPREC</td>
                      <td>$0.0040 / min</td>
                    </tr>
                    <tr>
                      <td>ConversationRelay</td>
                      <td>$0.07 / min</td>
                    </tr>
                    <tr>
                      <td>Gather Speech Recognition – default provider</td>
                      <td>$0.018 / use</td>
                    </tr>
                    <tr>
                      <td>Gather Speech Recognition – Deepgram / Google v2</td>
                      <td>$0.025 / use</td>
                    </tr>
                    <tr>
                      <td>Gather Speech Recognition – standard Google v1</td>
                      <td>$0.035 / use</td>
                    </tr>
                    <tr>
                      <td>Gather Speech Recognition – enhanced Google v1</td>
                      <td>$0.040 / use</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="mt-3">
                Note: When a 911 call is placed from a number without a
                registered emergency address, a $75 fee is charged per call.
              </p>
            </div>
          </div>

          <div className="row pt-5">
            <div className="col-lg-12">
              <div className="section-title">
                <h2>
                  Calls per <span>second (CPS)</span>
                </h2>
                <p>
                  Monthly CPS pricing is available with pay‑as‑you‑go and
                  committed‑use options.
                </p>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="table-responsive">
                <table className="table table-bordered text-start">
                  <thead>
                    <tr>
                      <th>Calls per second</th>
                      <th>Monthly pricing</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>Free</td>
                    </tr>
                    <tr>
                      <td>51+</td>
                      <td>Talk to sales</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="row pt-5 align-items-center">
            <div className="col-lg-6 col-md-12">
              <h3>Phone number pricing</h3>
              <p>Monthly fees by number type and volume.</p>
              <div className="table-responsive">
                <table className="table table-bordered text-start">
                  <thead>
                    <tr>
                      <th>Number type</th>
                      <th>0–1000 numbers</th>
                      <th>1000+ numbers</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Clean local numbers</td>
                      <td>$1.15 / mo</td>
                      <td>$0.575 / mo</td>
                    </tr>
                    <tr>
                      <td>Toll‑free numbers</td>
                      <td>$2.15 / mo</td>
                      <td>$1.613 / mo</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <img className="img-fluid" src={imgThree} alt="Placeholder" />
            </div>
          </div>

          <div className="row pt-5">
            <div className="col-lg-12">
              <div className="section-title">
                <h2>
                  In‑depth <span>US rates</span>
                </h2>
                <p>
                  Detailed rates for calling routes and inbound number types.
                </p>
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <h3>Make calls</h3>
              <div className="table-responsive">
                <table className="table table-bordered text-start">
                  <thead>
                    <tr>
                      <th>Route</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>United States &amp; Canada</td>
                      <td>$0.0140 / min</td>
                    </tr>
                    <tr>
                      <td>United States &amp; Canada – Toll‑Free</td>
                      <td>$0.0140 / min</td>
                    </tr>
                    <tr>
                      <td>United States – Alaska</td>
                      <td>$0.0945 / min</td>
                    </tr>
                    <tr>
                      <td>United States – Hawaii</td>
                      <td>$0.0140 / min</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <h3>Receive calls</h3>
              <div className="table-responsive">
                <table className="table table-bordered text-start">
                  <thead>
                    <tr>
                      <th>Number type</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Local</td>
                      <td>$0.0085 / min + $1.15 / mo</td>
                    </tr>
                    <tr>
                      <td>Toll‑Free</td>
                      <td>$0.0220 / min + $2.15 / mo</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="row pt-5">
            <div className="col-lg-12">
              <div className="section-title">
                <h2>
                  Ready to <span>talk pricing</span>?
                </h2>
                <p>
                  Tell us your call volume and regions, and we will tailor a
                  plan to your business.
                </p>
                <a href="/#contact" className="btn btn-primary">
                  Contact Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default VoicePricing;
